(() => {

  const DURATION = 600; // 10 Minutes
  const STORAGE_KEY = "cartTimerEnd";

  let interval = null;

  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  function format(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;

    return (
      String(m).padStart(2, "0") +
      ":" +
      String(s).padStart(2, "0")
    );
  }

  function showExpired() {

    const wrapper = document.getElementById("cart-countdown");

    if (!wrapper) return;

    wrapper.innerHTML = `
      <div class="cart-countdown-expired">
          ⏰ <strong>Reservation expired.</strong><br>
          Your cart has been cleared.
      </div>
    `;

  }

  async function clearCart() {

    await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });

    localStorage.removeItem(STORAGE_KEY);

    showExpired();

    setTimeout(() => {

      window.location.reload();

    },1500);

  }

  function startTimer(endTime){

    clearInterval(interval);

    function tick(){

      const timer = document.getElementById("cart-timer");

      if(!timer){

        clearInterval(interval);
        return;

      }

      let remain = Math.floor((endTime - Date.now())/1000);

      if(remain <= 0){

        clearInterval(interval);

        timer.innerHTML = "00:00";

        clearCart();

        return;

      }

      timer.innerHTML = format(remain);

    }

    tick();

    interval = setInterval(tick,1000);

  }

  async function init(){

    const timer = document.getElementById("cart-timer");

    if(!timer) return;

    const cart = await getCart();

    if(cart.item_count === 0){

      localStorage.removeItem(STORAGE_KEY);

      return;

    }

    let end = localStorage.getItem(STORAGE_KEY);

    if(!end){

      end = Date.now() + DURATION * 1000;

      localStorage.setItem(STORAGE_KEY,end);

    }

    startTimer(Number(end));

  }

  document.addEventListener("DOMContentLoaded", init);

  document.addEventListener("shopify:section:load", init);

  document.addEventListener("cart:updated", init);

  document.addEventListener("cart:refresh", init);

})();